import styled from "@emotion/styled";
import { useDeepCompareMemo } from "@react-hookz/web";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";

import type { ExtraProps } from "./scmp-youtube";

import { Iframe as ContentSchemaRenderIframe } from ".";

const getRenderIframeComponent = (extraProps: ExtraProps) => {
  const Component = (p: ContentSchemaRenderProps) => (
    <ContentSchemaRenderIframe {...p} {...extraProps} />
  );
  return styled(Component)``;
};

export function useContentSchemaRenderIframe(extraProps: ExtraProps) {
  const ComponentWithExtraProps = useDeepCompareMemo(
    () => getRenderIframeComponent(extraProps),
    [extraProps],
  );

  return {
    ComponentWithExtraProps,
  };
}
